import { RichText } from 'components_new/molecules/RichTextEditor/types'
import { TTaskResponse } from 'redux/api/Tasks'
import { EPublicationStatus } from './Enums'
import { TResourceFilter } from './GlobalDashboardGroup'
import { TReportWidget, TWidget, WidgetClass, WidgetType } from './GlobalWidget'
import { RollingType } from './GlobalKpiOption'
import { ShowPerEnum } from './GlobalMetric'

export type { TResourceFilter }

export type TAppliedFilter = {
  attribute_id: string
  values: string[]
}

export type TReport = {
  blocks: TReportBlock[]
  created_at: string
  description: RichText | null
  editions: string[]
  favorite: boolean
  folder_id: string | null
  id: string
  owner: string
  // ownership: any
  // share_settings: any
  report_filters: TResourceFilter[]
  status: EPublicationStatus
  tasks: TTaskResponse[]
  thumbnail: string | null
  title: string
  updated_at: string
  visited_at: Date | null
}

export type TReportEdition = {
  applied_filters: TAppliedFilter[] | null
  blocks: TReportBlock[]
  created_at: string
  from_date: string | null
  id: string
  locked_at: string | null
  owner: string
  report_id: string
  status: EPublicationStatus
  title: string | null
  to_date: string | null
  updated_at: string
}

export type TRefBlockWidget = {
  id: string
  title: string
  type: WidgetType
  show_subtitle: boolean
  show_title: boolean
  subtitle: string
  tooltip: string
  rich_text: RichText | null
}

export type TReportBlock = {
  id: string
  index: number
  report_id: string
  report_edition_id: string | null
  report_block_id: string | null
  widgets: TRefBlockWidget[]
}

export const isReportWidget = (
  widget: TRefBlockWidget | TWidget | null
): widget is TReportWidget => {
  return !!widget && 'class' in widget && widget.class === WidgetClass.REPORT
}

export type TCreateReportWidgetBody = {
  kpi_id: string | null
  variant_kpi_template_id?: string | null
  rolling_sum?: RollingType | null
  distribution?: ShowPerEnum | null
  slices?: string[]
  title?: string
  type?:
    | WidgetType.TEXT
    | WidgetType.COMMENT
    | WidgetType.IMAGE
    | WidgetType.RICH_TEXT
  report_block_id: string | null
}

export type TUpdateReportBody = {
  folder_id?: string | null
  description?: RichText | null
  title?: string
  status?: EPublicationStatus
}

type TKeyFigureEdit = {
  type: 'key_figure'
  kpi_option_index: number
  new_value: number
}

type TBreakdownEdit = {
  type: 'breakdown'
  row_index: number
  data_index: number
  new_value: number
}

type LockedWidgetEdit = TKeyFigureEdit | TBreakdownEdit

export type TEditLockedWidgetBody = {
  edit: LockedWidgetEdit
  reason?: string | null
}
